import { Component, OnInit } from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import { Title } from '@angular/platform-browser';
import { AppServiceService } from '../service/app-service.service';
import { RoleService } from '../service/role.service';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isAdmin: boolean;
  
  searchValue: String;
  public aFormGroup: FormGroup;
  
  public constructor(
	private roleService: RoleService, 
	public formBuilder: FormBuilder, 
	private appService: AppServiceService) { }
  
  pageTitle: String;

  
  ngOnInit(): void {
 
    //this.getUserRole();
  
    this.appService.title.subscribe(value => this.pageTitle = value);
    this.appService.searchString.subscribe(value => this.searchValue = value);
    
    this.aFormGroup = this.formBuilder.group({
      searchValue: new FormControl(null, Validators.required)
    });
    
  }


  getUserRole(): void {
    this.roleService.getUserRole().subscribe(res => this.isAdmin = res.isAdmin);
  }

  keyPress(event: any) {
    //const pattern = /^[a-zA-Z0-9* \-\']+/;
	const pattern = /^[a-zA-Z0-9* \-\'\@\.\/]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
  background: ThemePalette = undefined;


}
